import {
    AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { UserClient } from '../../../client/user.client';
import { Item } from '../../entity/entities';
import { FormMultiselectProperty } from '../../entity/form/formMultiselect.property';
import { GSBaseControl } from '../gs.base.control';

@Component({
  selector: 'app-users-by-roles',
  templateUrl: './gs.users-by-roles.component.html',
  styleUrls: ['./gs.users-by-roles.component.css'],
})
export class GsUsersByRolesComponent extends GSBaseControl implements OnInit, OnDestroy, AfterContentChecked {
  @Input() item: Item;
//  @Input() property;
  @Input() companyGroupCode: number;
  usersProperty: FormMultiselectProperty;
  rolesProperty: FormMultiselectProperty;

  constructor(
    @Optional() item: Item,
    private changeDr: ChangeDetectorRef,
    private userClient: UserClient) {
    super(changeDr);
    this.item = item;
  }    
    
  ngOnInit(): void {
    this.rolesProperty = new FormMultiselectProperty('Roles', 'Available roles', []);    
    this.usersProperty = new FormMultiselectProperty('Users', 'Excluded users by role', []);
   
    this.rolesProperty.parent = this.usersProperty.parent = this.property;
    this.rolesProperty.validate = this.usersProperty.validate = this.property.validate;
    this.rolesProperty.validateAllowNull = this.usersProperty.validateAllowNull = this.property.validateAllowNull;
    this.rolesProperty.validationType = this.usersProperty.validationType = this.property.validationType;
         
    this.userClient.getRoles(this.companyGroupCode).then((response) => {
      this.rolesProperty.options = [];
      response?.result.forEach((opt) => {
        this.rolesProperty.options.push({
          label: opt.Label,
          value: opt.Value,
          data: opt,
        });
      });
    });

    if (this.item?.data['Roles']?.length > 0) {
      this.handleUsersOptionCollection();
    }

    this.usersProperty.changed.subscribe(this.propertyChanged);
    this.rolesProperty.changed.subscribe(this.propertyChanged);
  }

  private handleUsersOptionCollection(callback?: () => void) {
        const getUsersRequest: any = {};
        getUsersRequest.RoleIDs = this.item?.data['Roles'];
        getUsersRequest.CompanyGroupCode = this.companyGroupCode;
        this.userClient.getUsers(getUsersRequest).then((response) => {
            this.usersProperty.options = [];
            response?.result.forEach((opt) => {
                this.usersProperty.options.push({
                    label: opt.FirstName + ' ' + opt.LastName + ', username:' + opt.UserName + ', email:' + opt.Email + ', phone:' + opt.PhoneNumber,
                    value: opt.Pk_ID,
                    data: opt,
                });                 
            });

            if (callback) {
              //remove missing options
              let currentAvailableOptions = this.usersProperty.options.map(x => x.value);
              let currentlyCheckedUserOptions = this.item.data['Users'];

              let optionsToRemove: [] = currentlyCheckedUserOptions.filter(v => !currentAvailableOptions.includes(v));
              if (optionsToRemove) {
                optionsToRemove?.forEach(option => {
                  this.item.data['Users'].splice(this.item.data['Users'].indexOf(option), 1);
                  this.item.data[this.property.name][1] = this.item.data['Users'];
                });
              }

              callback();
            }
        });
    }

  ngOnDestroy(): void {
    this.usersProperty.changed.unsubscribe();
    this.rolesProperty.changed.unsubscribe();
  }

  ngAfterContentChecked(): void {
    
  }

  propertyChanged = (val) => {
    const propertyName = val.propertyName;
    const previousValue : [] = val.previousValue ?? this.item.data[propertyName] ?? [];    
    const parentPropertyName = val.property.parent.name;
    const newValue : [] = val.newValue;

    let previousParentValue = this.item.data[parentPropertyName] ?? [[], []];
    let newParentValue = [[], []];

    if (propertyName == 'Roles') {    
      if (newValue.length == 0) {
        this.usersProperty.options = [];
        this.usersProperty.readonly = true;
        val.item.data['Users'] = [];
        val.item.data['Roles'] = [];
        this.item.data[parentPropertyName] = newParentValue;
        this.emitPropertyChangedEvent(propertyName, newValue, parentPropertyName, previousParentValue, newParentValue, val);
      }
      else {
        this.usersProperty.readonly = false;

        if (val.propertyName == 'Roles') {
          newParentValue[0] = newValue;
          newParentValue[1] = previousParentValue[1];
        }
        
        this.item.data[parentPropertyName] = newParentValue;
        //are equal
        if (previousValue.sort().join("") != newValue.sort().join("")) {
          this.usersProperty.options = [];
          this.handleUsersOptionCollection(() => this.emitPropertyChangedEvent(propertyName, newValue, parentPropertyName, previousParentValue, newParentValue, val));
        }        
      }     
    }

    if (propertyName == 'Users') {      
      newParentValue[0] = previousParentValue[0];
      newParentValue[1] = newValue;
      this.item.data[parentPropertyName] = newParentValue;
      this.emitPropertyChangedEvent(propertyName, newValue, parentPropertyName, previousParentValue, newParentValue, val);
    }


    //if (newValue && newValue.length > 0) {
    //  let previousParentValue = this.item.data[parentPropertyName];
      
    //  if (val.propertyName == 'Roles') {
    //    newParentValue[0] = newValue;
    //    newParentValue[1] = previousParentValue[1];
    //  }
    //  if (val.propertyName == 'Users') {
    //    newParentValue[0] = previousParentValue[0];
    //    newParentValue[1] = newValue;
    //  }
    //  this.item.data[parentPropertyName] = newParentValue;
    //}

    this.emitPropertyChangedEvent(propertyName, newValue, parentPropertyName, previousParentValue, newParentValue, val);
  };

  private emitPropertyChangedEvent(propertyName: any, newValue, parentPropertyName: any, previousParentValue: any, newParentValue: any[][], val: any) {
        this.item.data[propertyName] = newValue;

        this.property.changed.emit({
            propertyName: parentPropertyName,
            previousValue: previousParentValue,
            newValue: newParentValue,
            event: val.event,
            item: this.item,
            property: val.property,
        });
    }
}
